import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { trackEvent, scrollToId } from "@/lib/analytics";

const cards = [
  {
    title: "Resort Stays",
    copy: "Relaxing stays for families, couples, and simple getaways.",
    img: "https://images.unsplash.com/photo-1721908919546-f752b776f970?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZXNvcnQlMjBiZWFjaHxlbnwwfHx8fDE3ODI4Mzk4Mzd8MA&ixlib=rb-4.1.0&q=85",
    interest: "Resort Stay",
  },
  {
    title: "Cruises",
    copy: "Easy multi-destination travel for celebrations, families, and groups.",
    img: "https://images.unsplash.com/photo-1554254648-2d58a1bc3fd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjcnVpc2UlMjBzaGlwJTIwb2NlYW58ZW58MHx8fHwxNzgyODM5ODM3fDA&ixlib=rb-4.1.0&q=85",
    interest: "Cruise",
  },
  {
    title: "Group Travel",
    copy: "Curated experiences for festivals, birthdays, retreats, reunions, and special events.",
    img: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxncm91cCUyMGZyaWVuZHMlMjB2YWNhdGlvbnxlbnwwfHx8fDE3ODI4Mzk4Mzd8MA&ixlib=rb-4.1.0&q=85",
    interest: "Group Travel",
  },
];

export const FeaturedExperiences = ({ onSelectInterest }) => {
  const handle = (interest) => {
    trackEvent("cta_click", { location: "featured", cta: "request_info", interest });
    if (onSelectInterest) onSelectInterest(interest);
    scrollToId("lead-capture");
  };

  return (
    <section id="featured" data-testid="featured-section" className="py-20 md:py-32 bg-[#EAE4DA]/40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <p className="uppercase text-sm tracking-[0.2em] font-semibold text-terracotta mb-4">
            Where will you go?
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-ink">
            Featured Travel Experiences
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {cards.map((c) => (
            <article
              key={c.title}
              data-testid={`featured-card-${c.interest.toLowerCase().replace(/\s+/g, "-")}`}
              className="group overflow-hidden rounded-3xl bg-white border border-bone shadow-sm hover:shadow-xl transition-all duration-500 flex flex-col"
            >
              <div className="overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-[320px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="font-serif text-2xl font-semibold text-ink mb-3">{c.title}</h3>
                <p className="text-base leading-relaxed text-ink-soft flex-1">{c.copy}</p>
                <Button
                  data-testid={`featured-request-${c.interest.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() => handle(c.interest)}
                  variant="ghost"
                  className="mt-6 self-start rounded-full px-0 text-terracotta hover:text-terracotta-hover hover:bg-transparent font-semibold group/btn"
                >
                  Request Info
                  <ArrowRight size={18} className="ml-1 transition-transform group-hover/btn:translate-x-1" />
                </Button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
